export const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  borderRadius: 6,
  border: "1px solid var(--line-2)",
  background: "var(--paper-0)",
  color: "var(--ink)",
  fontSize: 13,
  fontFamily: "var(--ui)",
  boxSizing: "border-box",
  marginBottom: 6,
  outline: "none",
};

export const selectStyle = {
  ...inputStyle,
  appearance: "auto",
};
